<template lang="pug">
.layout
  y-dialog(
    fill-height,
    fluid,
    v-model="showModal",
    scrollable,
    transition="fade-transition",
    persistent,
    max-width="600px",
    :fullscreen="$vuetify.breakpoint.xsOnly",
  )
    v-card(
      min-height="80vh"
    )
      v-card-title.px-5(
        :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`"
      )
        v-row(no-gutters, align="center")
          v-col.shrink
            v-btn.ml-n3(text, icon, @click="showModal = !showModal", height)
              eva-icon(
                name="close-outline",
                :fill="$vuetify.theme.themes[$theme].basic800",
                width="24",
                height="24"
              )
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ data.income != null ? `#${data.id} ${data.income.name}` : shortDescription }}
          v-col.ml-3.shrink(v-if="showStopScheduledButton")
            v-btn.elevation-0.pa-0(
              text,
              color="transparent",
              :ripple="false",
              x-small,
              light,
              @click="openStopDialog = true",
            )
              .button-Aa-small.danger--text.text-capitalize Stop
      v-card-text.pa-6()
        .s1.textDefault--text Reminders
        v-layout.my-12(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        v-card.mt-2(v-else outlined)
          v-simple-table.mytable(fixed-header v-if="reminderList.length > 0" )
            template(v-slot:default)
              thead
                tr
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") Date
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") Status
              tbody()
                tr(v-for="(reminder,index) in reminderList" :key="index")
                  td.py-2
                    div.p2.default--text {{reminder.date | dateFormat}} at {{convert24to12(reminder.data.send_time)}}
                  td.py-2
                    div.p2.default--text(v-if="reminder.data.result") {{reminder.data.result.status | capitalize }}
                    div.p2.default--text(v-else) Scheduled
              tbody(v-if="reminderList.length == 0")
                tr()
                  td.py-2(colspan="2")
                    div.p2.default--text No more schedules
          v-simple-table.mytable(fixed-header v-else )
            template(v-slot:default)
              thead
                tr
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") Date
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") Status
              tbody
                tr()
                  td.py-2.text-center(colspan="2")
                    div.p2.default--text No more schedules
        v-row.px-3(v-if="!isFetching" )
          v-col.py-1.px-0.text-end
            v-btn.mr-1.rounded-l.primary500(@click="goPast" tile icon height="24" width="24")
              eva-icon(style="padding-top: 2px; padding-right: 2px;" name="arrow-ios-back-outline" height="14" :fill="$vuetify.theme.themes[$theme].basic100")
            v-btn.ml-1.rounded-r.primary500(@click="goNext" tile icon height="24" width="24")
              eva-icon(style="padding-top: 2px; padding-right: 2px;" name="arrow-ios-forward-outline" height="14" :fill="$vuetify.theme.themes[$theme].basic100")

        .s1.textDefault--text.mt-6 Sent through:
        v-card.mt-2( flat outlined width="100%")
          v-card-text.pa-4
            div(v-for="(channel, index) in data.channels" :key="index")
              div.p1.primary400--text.text-capitalize - {{channel}}
  .modals
    y-dialog(v-if="openStopDialog" v-model='openStopDialog', max-width='340')
      v-card
        v-card-title.h6.basic800--text.px-4 Stop scheduled reminder
        v-card-text.p2.primary500--text.px-4
          div Are you sure you want to stop scheduled reminder? This item will be deleted permanently.
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='openStopDialog = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='danger500' depressed height=32 @click='stopScheduled' :loading="isLoading" dark)
            .button-AA-small.basic100--text Stop
    
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  components:{},
  props: ["open","data"],
  data: () => ({
    reminderList:[],
    reminders:[],
    messageTemplate: "Hi, I'm {{name}},<br><br>interested to buy<br>{{product_description}}<br><br>Buy now? Order here : {{store_link}}",
    formLanguage: 'en',
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' },
      { name: 'Chinese', id: 'zh' },
      { name: 'Tamil', id: 'ta' },
    ],
    isFetching: false,
    fromDays: -7,
    toDays: 0,
    fromDate:'',
    toDate:'',
    openStopDialog: false,
    isLoading: false,
    showStopScheduledButton: false
  }),
  mounted(){
    this.fetchSchedules()
  },
  filters: {
    dateFormat(val) {
      if (val) {
        var newDate = new Date(val);
        var dd =
          newDate.getDate().toString().length < 2
            ? "0" + newDate.getDate()
            : newDate.getDate();
        var mm =
          (newDate.getMonth()+1).toString().length < 2
            ? "0" + (newDate.getMonth()+1)
            : newDate.getMonth()+1;
        var yy = newDate.getFullYear();
        return dd + "/" + mm + "/" + yy;
      } else {
        return "--/--/----";
      }
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    shortDescription(){
      const categories = this.data.expense.category_items
      const length = categories.length;
      if (length == 0) {
        return 'Null Description'
      }else{
        if (length == 1) {
          return this.textLimit(categories[0].description,30);
        }else{
          var more =  length - 1;
          return this.textLimit(categories[0].description,20) + " +" + more + " more";
        }
      }
    },
  },
  methods: {
    fetchSchedules() {
      this.isFetching = true
      this.fromDate = this.countDate('past',this.fromDays + 7)
      this.toDate = this.countDate('next',this.toDays + 7)
      let url = `/books/${this.company.slug}/scheduled_reminders/schedules?from=${this.fromDate}&until=${this.toDate}&expand=income,expense.category_items,expense.category_items.category`
      this.$axios.get(url).then((response) => {
        let array = []
        array = {...response}
        this.reminders = [...array.data]
        this.getReminderList()
      }).catch(() => {})
    },
    convert24to12(timeString){
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? "AM" : "PM";
      return timeString = h + timeString.substr(2, 3) + ampm;
    },
    getReminderList(){
      this.reminderList = []
      for (let i = 0; i < this.reminders.length; i++) {
        const items = this.reminders[i].reminders
        const date = this.reminders[i].date
        for (let j = 0; j < items.length; j++) {
          const item = items[j]
          if (this.data.id === item.id) {
            const newArray = {
              date: date,
              data: item
            }
            this.reminderList.push(newArray)
            if (!item.result) {
              this.showStopScheduledButton = true
            }
          }
        }
      }
      this.isFetching = false
    },
    goNext() {
      this.fromDays -= 8
      this.toDays += 8
      this.fetchSchedules()
    },
    goPast() {
      this.fromDays += 8
      this.toDays -= 8
      this.fetchSchedules()
    },
    countDate(sit,count){ //sit = past/next
      var date = new Date();
      if (sit == 'past') {
        date.setDate(date.getDate() - count);
      } else if (sit == 'next') {
        date.setDate(date.getDate() + count);
      } else {
        date.setDate(date.getDate());
      }
      return date = date.toISOString().split('T')[0]; // "yyyy-mm-dd"
    },

    textLimit(text,max){
      if (text.length > max && this.$vuetify.breakpoint.width < 411 && this.$vuetify.breakpoint.width > 330) {
        return `${text.substring(0, max - 1)}...`
      }else if (text.length > max && this.$vuetify.breakpoint.width < 340) {
        return `${text.substring(0, max - 6)}...`
      }
      return text
    },
    stopScheduled() {
      this.isLoading = true
      this.axios.patch(`/books/${this.company.slug}/scheduled_reminders/${this.data.id}/`, { stopped_at: new Date().toISOString(), repeat: this.data.repeat })
        .then(() => {
          this.$emit('stopped')
          this.fetchSchedules()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
};
</script>